import React, { useEffect } from 'react';

const PickerModal = ({ 
  showPicker, 
  pickerSearch, 
  setPickerSearch, 
  getFilteredOptions, 
  getSelectedIndexInFiltered, 
  pickerValue,
  selectPickerValue,
  closePicker 
}) => {
  // Закрытие окна выбора по Escape
  useEffect(() => {
    if (!showPicker) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        closePicker();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [showPicker, closePicker]);

  if (!showPicker) return null;

  return (
    <div className="picker-overlay" onClick={closePicker}>
      <div className="picker-modal" onClick={(e) => e.stopPropagation()}>
        <div className="picker-header">
          <h3>Выберите значение</h3>
          <button className="picker-close" onClick={closePicker}>×</button>
        </div>
        <div className="picker-search">
          <input
            type="text"
            placeholder="Поиск..."
            value={pickerSearch}
            onChange={(e) => setPickerSearch(e.target.value)}
            className="picker-search-input"
            autoFocus
          />
          {pickerSearch && (
            <button
              className="picker-search-clear"
              onClick={() => setPickerSearch('')}
              title="Очистить поиск"
            >
              ✕
            </button>
          )}
        </div>
        <div className="picker-content">
          {getFilteredOptions().length > 0 ? (
            <ul className="picker-list">
              {getFilteredOptions().map((option, index, options) => {
                const isSelected = pickerValue === option.value;
                const isHighlighted = index === getSelectedIndexInFiltered();
                // Частые значения идут первыми — отделяем их от остального списка
                const previous = options[index - 1];
                const afterPriority = Boolean(previous && previous.priority && !option.priority);
                return (
                  <li 
                    key={option.value} 
                    onClick={() => selectPickerValue(option.value)}
                    className={`${isSelected ? 'selected' : ''} ${isHighlighted ? 'highlighted' : ''} ${afterPriority ? 'picker-after-priority' : ''}`}
                    style={{
                      backgroundColor: isHighlighted ? '#e3f2fd' : 'transparent'
                    }}
                  >
                    <div style={{ fontWeight: '500' }}>{option.label}</div>
                    {option.description && (
                      <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                        {option.description}
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          ) : (
            <div className="picker-no-results">
              <p>Ничего не найдено</p>
              <p style={{ fontSize: '12px', color: '#666' }}>
                Попробуйте изменить поисковый запрос
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PickerModal;

